import fb from '../firebase'
import FirebaseHelpers from '../helpers/FirebaseHelpers'
import DataHelpers from '../helpers/DataHelpers'
import ListHelpers from '../helpers/ListHelpers'
import DateHelpers from '../helpers/DateHelpers'
import Utilities from '../helpers/Utilities'
import NiceData from '../data/NiceData'
import { debug } from 'util';

var db = fb.database()

const state = {
    tasks: [],
    selectedTask: null,
}

// getters
const getters = {
    tasks: state => {
        return state.tasks
    },
    selectedTask: state => {
        return state.selectedTask
    },
}

// actions
const actions = {

    loadTasks(context) {
        return new Promise(function(resolve, reject) {

            let ref = db.ref(`tenants/${context.getters.tenantKey}/tasks`)
            let transactionKey = DataHelpers.getTransactionKey()
            
            ref.orderByChild('transactionKey').equalTo(transactionKey).on('value', function(snap) {
                Utilities.log('store > loadTasks (first load)')
                let tasks = FirebaseHelpers.snapshotToArray(snap)
                context.commit('setTasks', tasks)
                resolve('loaded')
            })  
        })
    },
    
    selectTask(context, obj) {
        context.commit('setSelectedTask', obj)
        context.commit('allCommentsMode', false)
    },

    saveTask(context, obj) {
        Utilities.log('TasksStore > saveTask', obj)
        obj.key = NiceData.safelyGetKey(obj) || DataHelpers.getKey()
        obj.transactionKey = obj.transactionKey || context.getters.transaction.key
        obj.clients = obj.clients || context.getters.transaction.clients
        obj.tenantKey = obj.tenantKey || context.getters.tenantKey
        obj.due = obj.due || DateHelpers.businessDaysFromNow(1).formatBackwards()
        obj.assigned = obj.assigned || context.getters.user
        let newObj = ListHelpers.prepareSave(obj) 
        context.commit('saveTask', newObj)
        let ref = DataHelpers.getTenantRef().child('tasks')
        FirebaseHelpers.saveToFirebase(newObj, ref)
    },

    deleteTask(context, obj) {
        Utilities.log('TasksStore > deleteTask', obj)
        context.commit('deleteTask', obj)
        let ref = DataHelpers.getTenantRef().child('tasks')
        FirebaseHelpers.deleteFromFirebase(obj, ref)
    }
}

// mutations
const mutations = {
                   
    setTasks (state, newVal) {
        state.tasks = newVal           
    },                                         
    setSelectedTask (state, newVal) {
        state.selectedTask = newVal  
    },                                         
    saveTask (state, task) {
        ListHelpers.save(task, state.tasks, 0)          
    },                      
    deleteTask (state, task) {
        ListHelpers.delete(task, state.tasks)          
    },                      
}

export default {
  state,
  getters,
  actions,
  mutations
}


// WEBPACK FOOTER //
// ./src/store/TasksStore.js